"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSelectedTenant = exports.deleteClient = exports.updateClient = exports.createClient = exports.fetchClients = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _reduxBatchedActions = require("redux-batched-actions");

var _actions = require("skybase-ui/skybase-core/base/actions");

var _constants = require("./constants");

var _actions2 = require("../actions");

var _rest = require("../rest");

var _actions3 = require("./actions");

var _constants2 = require("../constants");

var _utils = require("../utils");

var _clientsI18n = require("./clients-i18n");

var _messagesI18n = require("../messages-i18n");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var NORMAL = _constants2.STATES.NORMAL,
    LOADING = _constants2.STATES.LOADING;

var fetchClients = function fetchClients(pageSize, pageNumber, _) {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(dispatch) {
      var _yield$getClientsApi, _yield$getClientsApi$, clients, listConfig;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              dispatch((0, _actions3.changeListClientsState)(LOADING));
              _context.next = 4;
              return (0, _rest.getClientsApi)(pageSize, pageNumber);

            case 4:
              _yield$getClientsApi = _context.sent;
              _yield$getClientsApi$ = _yield$getClientsApi.records;
              clients = _yield$getClientsApi$ === void 0 ? [] : _yield$getClientsApi$;
              listConfig = (0, _objectWithoutProperties2.default)(_yield$getClientsApi, ["records"]);
              dispatch((0, _reduxBatchedActions.batchActions)([(0, _actions3.changeListClientsState)(NORMAL), (0, _actions3.setClients)(clients.map(function (client) {
                return _objectSpread(_objectSpread({}, client), {}, {
                  tempId: client.id
                });
              })), (0, _actions3.changeClientListConfig)(listConfig)]));
              _context.next = 16;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](0);
              dispatch((0, _actions3.changeListClientsState)(NORMAL)); // todo handle errors

              console.log(_context.t0);
              dispatch((0, _actions2.showErrorToastFactory)({
                title: _(_messagesI18n.messages.error),
                message: _(_clientsI18n.messages.errorDuringClientsFetch)
              }));

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 11]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.fetchClients = fetchClients;

var createClient = function createClient(client, _ref2, _) {
  var pageSize = _ref2.pageSize,
      pageNumber = _ref2.pageNumber;
  return /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(dispatch) {
      var errorCode;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              dispatch((0, _actions3.changeCreateClientState)(LOADING));
              _context2.next = 4;
              return (0, _rest.createClientApi)(client);

            case 4:
              dispatch((0, _reduxBatchedActions.batchActions)([(0, _actions3.changeCreateClientState)(NORMAL), (0, _actions3.clearCreateClientParams)(), (0, _actions.closeModal)()]));
              dispatch((0, _actions2.showSuccessToastFactory)({
                title: _(_messagesI18n.messages.success),
                message: _(_clientsI18n.messages.clientSuccessfullyCreated)
              }));
              dispatch(fetchClients(pageSize, pageNumber, _));
              _context2.next = 19;
              break;

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](0);
              dispatch((0, _actions3.changeCreateClientState)(NORMAL));
              errorCode = (0, _utils.getErrorCode)(_context2.t0);
              _context2.t1 = errorCode;
              _context2.next = _context2.t1 === 409 ? 16 : 18;
              break;

            case 16:
              dispatch((0, _actions2.showErrorToastFactory)({
                title: _messagesI18n.messages.error,
                message: _clientsI18n.messages.clientAlreadyExists
              }));
              return _context2.abrupt("break", 19);

            case 18:
              dispatch((0, _actions2.showErrorToastFactory)({
                title: _messagesI18n.messages.error,
                message: _clientsI18n.messages.errorDuringClientCreation
              }));

            case 19:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 9]]);
    }));

    return function (_x2) {
      return _ref3.apply(this, arguments);
    };
  }();
};

exports.createClient = createClient;

var updateClient = function updateClient(client, _ref4, _) {
  var pageSize = _ref4.pageSize,
      pageNumber = _ref4.pageNumber;
  return /*#__PURE__*/function () {
    var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(dispatch) {
      var errorCode;
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              dispatch((0, _actions3.changeUpdateClientState)(LOADING));
              _context3.next = 4;
              return (0, _rest.updateClientApi)(client);

            case 4:
              dispatch((0, _reduxBatchedActions.batchActions)([(0, _actions3.changeUpdateClientState)(NORMAL), (0, _actions3.changeLoadedClientTempId)(client.id), (0, _actions3.changeUpdateClientParams)('secret', ''), (0, _actions.closeModal)()]));
              dispatch((0, _actions2.showSuccessToastFactory)({
                title: _(_messagesI18n.messages.success),
                message: _(_clientsI18n.messages.clientSuccessfullyUpdated)
              }));
              dispatch(fetchClients(pageSize, pageNumber, _));
              _context3.next = 19;
              break;

            case 9:
              _context3.prev = 9;
              _context3.t0 = _context3["catch"](0);
              dispatch((0, _actions3.changeUpdateClientState)(NORMAL));
              errorCode = (0, _utils.getErrorCode)(_context3.t0);
              _context3.t1 = errorCode;
              _context3.next = _context3.t1 === 409 ? 16 : 18;
              break;

            case 16:
              dispatch((0, _actions2.showErrorToastFactory)({
                title: _messagesI18n.messages.error,
                message: _clientsI18n.messages.clientAlreadyExists
              }));
              return _context3.abrupt("break", 19);

            case 18:
              dispatch((0, _actions2.showErrorToastFactory)({
                title: _(_messagesI18n.messages.error),
                message: _(_clientsI18n.messages.errorDuringClientUpdate)
              }));

            case 19:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 9]]);
    }));

    return function (_x3) {
      return _ref5.apply(this, arguments);
    };
  }();
};

exports.updateClient = updateClient;

var deleteClient = function deleteClient(id, _ref6, _) {
  var pageSize = _ref6.pageSize,
      pageNumber = _ref6.pageNumber;
  return /*#__PURE__*/function () {
    var _ref7 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(dispatch) {
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return (0, _rest.deleteClientApi)(id);

            case 3:
              dispatch((0, _actions3.clearAllClientForms)());
              dispatch((0, _actions2.showSuccessToastFactory)({
                title: _(_messagesI18n.messages.success),
                message: _(_clientsI18n.messages.clientSuccessfullyDeleted)
              }));
              dispatch(fetchClients(pageSize, pageNumber, _));
              _context4.next = 12;
              break;

            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](0);
              // todo handle errors
              console.log(_context4.t0);
              dispatch((0, _actions2.showErrorToastFactory)({
                title: _(_messagesI18n.messages.error),
                message: _(_clientsI18n.messages.errorDuringClientDeletion)
              }));

            case 12:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 8]]);
    }));

    return function (_x4) {
      return _ref7.apply(this, arguments);
    };
  }();
}; // If value === '' then check if tenant already set in dropdown and do not reset it


exports.deleteClient = deleteClient;

var getSelectedTenant = function getSelectedTenant(value, tenantAccessPolicy) {
  return value === '' && tenantAccessPolicy !== _constants.SYSTEM_CLIENT ? tenantAccessPolicy : value;
};

exports.getSelectedTenant = getSelectedTenant;
//# sourceMappingURL=utils.js.map